module.exports = __webpack_public_path__ + "static/media/SetantaEurasia_PanRussia.34729299.png";